import { masterClient } from '~/core/utils/clients/masterClient'
import type { Category } from '~/core/enums'

const RESOURCE = '/favourites'

export type FavouritePreviewDto = {
  avatar: string
  // Это id врача/клиники, а не сущности избранного
  id: number
  info: string
  name: string
  type: Category.Doctors | Category.Lpu
  urlPath: string
  dtUpdated: DateTimeISO
  rating: number
  rates: number
  familyProfileUuid: string | null
}

export const FavouritesApi = {
  get(type?: Category.Doctors | Category.Lpu) {
    return masterClient.get<FavouritePreviewDto[]>(`${RESOURCE}/`, {
      params: {
        type,
      },
      camelize: true,
    })
  },

  add(type: string, id: number, family_profile_uuid?: string | null) {
    return masterClient.post(`${RESOURCE}/${type}/${id}/`, { camelize: true, family_profile_uuid })
  },
  delete(type: string, id: number) {
    return masterClient.delete(`${RESOURCE}/${type}/${id}/`, { camelize: true })
  },
}
